import React from 'react';
import { Order } from '../../../../utils/apollo/graphqlSchema';
import { orderIconLookup } from '../../../../utils/builder';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { changeBreakdownOrder } from '../../../../redux/slices/oldBuilder';
import KubitTooltip from '../../../KubitTooltip';
import { SvgIcon } from '../../../Icon';

const BreakdownOrder = () => {
  const dispatch = useAppDispatch();
  const order = useAppSelector(({ builder }) => builder.breakdown.order);

  const groupOrderIsAsc = order === Order.Asc;

  const content = `Change to ${
    groupOrderIsAsc ? 'descending' : 'ascending'
  } order`;

  const handleClick = () => {
    dispatch(changeBreakdownOrder(groupOrderIsAsc ? Order.Desc : Order.Asc));
  };

  return (
    <KubitTooltip content={content} noOpenDelay={true}>
      <SvgIcon
        name={orderIconLookup[order]}
        width={16}
        height={16}
        onClick={handleClick}
        isHoverable
      />
    </KubitTooltip>
  );
};

export default BreakdownOrder;
